

import MovieClip = createjs.MovieClip;

export class BasicDragVO {
    public dragMC: MovieClip;
    public dragSourceMC: MovieClip;
}

